import {
  EBenefitProgram,
  EEmploymentType,
  EIncomeConfirmation,
  EObjectType,
  ERealEstateType,
  IGetAvailableMultiOffersRequestV2,
} from '../../repositories/mortgage-broker-calculator/entities/get_avaiable_multi_offers_v2/GetAvailableMultiOffersRequestV2';
import { ICalculatorMcfValues } from '../../types/features';

/**
 * Собирает объект запроса getOfferListingV2 из значений калькулятора.
 * Используется и на node (fetchOffers), и на клиенте (useGetMappedOffers),
 * чтобы ключ кэша RTK Query совпадал и не было повторного запроса при гидрации.
 * Для отсутствующих или невалидных полей подставляются значения из defaults
 * (на node и клиенте — из landing.calculatorDefaultValues, заполняемых из defaultFilters ответа get-settings).
 */
export const buildGetOfferListingRequest = (
  parameters: ICalculatorMcfValues,
  defaults: Partial<ICalculatorMcfValues>,
): IGetAvailableMultiOffersRequestV2 => {
  const regionIdValue = parameters.regionId != null && parameters.regionId !== '' ? Number(parameters.regionId) : null;
  const regionId = regionIdValue != null && !isNaN(regionIdValue) && regionIdValue > 0 ? regionIdValue : 1;

  const loanTermYears = Number(parameters.loanTerm);
  const payrollBankNum = Number(parameters.payrollBank);

  const resolvedLoanTerm =
    Number.isFinite(loanTermYears) && loanTermYears > 0 ? loanTermYears : (defaults.loanTerm ?? 30);
  const resolvedObjectCost =
    parameters.objectCost != null && Number.isFinite(parameters.objectCost) && parameters.objectCost > 0
      ? parameters.objectCost
      : (defaults.objectCost ?? 12_000_000);
  const resolvedDownPayment =
    parameters.downPayment != null && Number.isFinite(parameters.downPayment) && parameters.downPayment >= 0
      ? parameters.downPayment
      : (defaults.downPayment ?? 4_000_000);

  return {
    regionId,
    loanTermYears: resolvedLoanTerm,
    objectCost: resolvedObjectCost,
    downPayment: resolvedDownPayment,
    incomeConfirmation: parameters.incomeConfirm ?? defaults.incomeConfirm ?? EIncomeConfirmation.Confirmation,
    realEstateType: parameters.realEstateType ?? defaults.realEstateType ?? ERealEstateType.NewBuilding,
    objectType: parameters.objectType ?? defaults.objectType ?? EObjectType.Flat,
    benefitProgram: parameters.benefitProgram ?? defaults.benefitProgram ?? EBenefitProgram.NoProgram,
    employmentType: parameters.typeOfEmployment ?? defaults.typeOfEmployment ?? EEmploymentType.Employee,
    payrollBankId: Number.isFinite(payrollBankNum) ? payrollBankNum : null,
  } as unknown as IGetAvailableMultiOffersRequestV2;
};
